import {SiMarketo} from "react-icons/si";
import {GiRoundStar} from "react-icons/gi";
import {BsFillSuitHeartFill} from "react-icons/bs";
import {FaBox} from "react-icons/fa";
import {BsHexagonHalf} from "react-icons/bs"

export const softwareHub=[
    {
        name:'Marketing Hub',
        img:<SiMarketo/>,
        discribe:"Marketing automation software",
        path:"/toppage",
        plans:"Free and premium plans"
    },
    {
        name:'Sales Hub',
        img:<GiRoundStar/>,
        discribe:"Sale CRM software",
        path:"/",
        plans:"Free and premium plans"
    },
    {
        name:'Service Hub',
        img:<BsFillSuitHeartFill/>,
        discribe:"Customer service software",
        path:"/",
        plans:"Free and premium plans"
    },
    {
        name:'CMS Hub',
        img:<FaBox/>,
        discribe:"Content management software",
        path:"/",
        plans:"Free and premium plans"
    },
    {
        name:'Operations Hub',
        img:<BsHexagonHalf/>,
        discribe:"Operations software",
        path:"/",
        plans:"Free and premium plans"
    }
]